module.exports = function () {
    // Smooth Scroll
    // Select all links with hashes
    $('a[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function (event) {
            // On-page links
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
                location.hostname == this.hostname
            ) {
                // Figure out element to scroll to
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happens
                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: target.offset().top - 130
                    }, 1000);
                }
            }
        });

    const scrollOnPageLoad = () => {
        // to top right away
        // if (window.location.hash) scroll(0, 0);
        // void some browsers issue
        var hashLink = window.location.hash;
        if ($(hashLink).length) {
            // *only* if we have anchor on the url
            // smooth scroll to the anchor id
            setTimeout(() => {
                $('html, body').animate({
                    scrollTop: $(window.location.hash).offset().top - 130
                }, 500);
            }, 500);
        }
    }

    setTimeout(scroll(0, 0), 2);
    window.addEventListener('load', function () {
        scrollOnPageLoad();
    })
    const scrollToTopBtn = document.getElementById("scrollToTopBtn");
    const rootElement = document.documentElement;

    function scrollToTop() {    
    // Scroll to top logic
    rootElement.scrollTo({
        top: 0,
        behavior: "smooth"
    });
    }
    scrollToTopBtn.addEventListener("click", scrollToTop);
};

